<template>
  <ShBlade
    :visible="visible"
    @update:visible="closeProfileMenu"
  >
    <div class="profileMenu__body">
      <settings-nav />
    </div>
  </ShBlade>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { ShBlade } from '@sohohouse/design-system'

import UIMixin from '~/mixins/ui'
import UserGreeting from '~/components/user-greeting'
import SettingsNav from '~/components/settings-nav/SettingsNav'

const { mapActions: mapModalActions, mapGetters: mapModalGetters } = createNamespacedHelpers('ui/modals')

export default {
  name: 'ProfileMenu',

  components: {
    ShBlade,
    UserGreeting,
    SettingsNav
  },

  mixins: [
    UIMixin
  ],

  data () {
    return {
      name: 'profile-menu'
    }
  },

  computed: {
    ...mapModalGetters(['openModals']),

    visible () {
      return this.openModals.includes(this.name)
    }
  },

  watch: {
    '$route.path': 'closeProfileMenu'
  },

  methods: {
    ...mapModalActions(['close']),

    closeProfileMenu () {
      this.$ui.modal.close(this.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.profileMenu {
  &__body {
    padding: 0 $space-040;
  }
}
</style>
